import { render, staticRenderFns } from "./SluzbaPrintDetail.vue?vue&type=template&id=74875d1e&scoped=true&"
import script from "./SluzbaPrintDetail.vue?vue&type=script&lang=js&"
export * from "./SluzbaPrintDetail.vue?vue&type=script&lang=js&"
import style0 from "./SluzbaPrintDetail.vue?vue&type=style&index=0&id=74875d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74875d1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\4g22\\themes\\foreground-theme-2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74875d1e')) {
      api.createRecord('74875d1e', component.options)
    } else {
      api.reload('74875d1e', component.options)
    }
    module.hot.accept("./SluzbaPrintDetail.vue?vue&type=template&id=74875d1e&scoped=true&", function () {
      api.rerender('74875d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/sluzby/SluzbaPrintDetail.vue"
export default component.exports